import React from "react";
import FeatureSection from "../components/FeatureSection";

const featureImage1 =
  "https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67f50c9468bf33e1f9810b2d_Frame%205%20(1).png";
const featureImage2 =
  "https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67fcd3b6d163ed8c3094583d_coupon%20(2).png";
const featureImage3 =
  "https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67fcd467439df7fe204e3bad_medium-shot-woman-working-laptop%201.png";

function CouponPage() {
  return (
    <div className="flex flex-col">
      {/* Section 1 */}
      <FeatureSection
        image={featureImage1}
        title="
            Turn Great Service into Repeat Business

            "
        description="
With Zola, every positive customer experience becomes a chance to grow. Our coupon system is designed to reward loyalty, encourage referrals, and boost repeat visits—all on autopilot.
            
            "
      />

      {/* Section 2 */}
      <FeatureSection
        image={featureImage2}
        title="
            Intelligent Coupon Triggers

            "
        description="
Design special promo codes to reward returning customers and boost long-term engagement.
            "
        reverse
      />

      {/* Section 3 */}
      <FeatureSection
        image={featureImage3}
        title="
            Build Loyalty & Referral Momentum
            "
        description="
Provide tailored coupon codes to keep your customers engaged and coming back for more.
            "
      />
    </div>
  );
}

export default CouponPage;
